import { Stack, Text, Title } from "@mantine/core";

import type { SalesMessageMetadata } from "../../../shared-types/types";

export function SalesMessage({ metadata }: { metadata: SalesMessageMetadata }) {
    return (
        <Stack gap={4} mt={"md"}>
            <Title size="xs" fw={400} c="dark.2">
                {metadata.title}
            </Title>
            <Text size="md" fw={600}>
                {metadata.text}
            </Text>
        </Stack>
    );
}
